/**
 * Mobile menu (below 1200px): a full-screen sheet under the header bar. An item with children opens its own screen
 * (html[data-menu-level="2"]), and Back in the bar returns to the list.
 */
export default (el) => {
  const root = document.documentElement,
        header = el.closest('.site-header'),
        toggle = header.querySelector('.js-menu-toggle'),
        back = header.querySelector('.js-menu-back'),
        list = el.querySelector('.hamburger-menu-root'),
        rows = [...el.querySelectorAll('button.hamburger-menu-row')],
        desktop = window.matchMedia('(min-width: 1200px)')
  ;

  const panelFor = (row) => document.getElementById(row.getAttribute('aria-controls'));
  const isOpen = () => root.getAttribute('data-menu') === 'open';
  const openRow = () => rows.find((row) => row.getAttribute('aria-expanded') === 'true');

  // Show an item's screen, or the top level (row = null)
  const show = (row, instant = false) => {
    if (instant) {
      el.classList.add('-instant');
      void el.offsetWidth;
    }
    rows.forEach((r) => {
      const panel = panelFor(r),
            active = r === row;
      r.setAttribute('aria-expanded', String(active));
      panel.classList.toggle('-active', active);
      panel.inert = !active;
      if (active) {
        panel.scrollTop = 0;
      }
    });
    list.inert = !!row;
    root.setAttribute('data-menu-level', row ? '2' : '1');
    if (instant) {
      void el.offsetWidth;
      el.classList.remove('-instant');
    }
  };

  const open = () => {
    show(null, true);
    el.style.setProperty('--hamburger-menu-top', `${header.getBoundingClientRect().bottom}px`);
    root.setAttribute('data-menu', 'open');
    el.inert = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', toggle.dataset.labelClose);
  };

  const close = (returnFocus = false) => {
    if (!isOpen()) {
      return;
    }
    root.setAttribute('data-menu', 'closed');
    root.setAttribute('data-menu-level', '1');
    el.inert = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', toggle.dataset.labelOpen);
    if (returnFocus) {
      toggle.focus();
    }
  };

  const backToList = () => {
    const row = openRow();
    show(null);
    if (row) {
      row.focus({ preventScroll: true });
    }
  };

  toggle.addEventListener('click', () => (isOpen() ? close() : open()));

  rows.forEach((row) => {
    row.addEventListener('click', (e) => {
      show(row);
      // From the keyboard (Enter or Space), focus follows into the screen
      if (!e.detail) {
        back.focus({ preventScroll: true });
      }
    });
  });

  back.addEventListener('click', backToList);

  document.addEventListener('keydown', ({ key }) => {
    if ((key === 'Escape' || key === 'Esc') && isOpen()) {
      if (openRow()) {
        backToList();
      } else {
        close(true);
      }
    }
  });

  // Search opens over the page, so the menu closes first
  header.querySelectorAll('.js-search-open').forEach((button) => button.addEventListener('click', () => close()));

  const onDesktopChange = ({ matches }) => {
    if (matches) {
      close();
    }
  };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', onDesktopChange);
  } else {
    desktop.addListener(onDesktopChange);
  }

  window.addEventListener('resize', () => {
    if (isOpen()) {
      el.style.setProperty('--hamburger-menu-top', `${header.getBoundingClientRect().bottom}px`);
    }
  });
};
